// @flow
import React, { Component } from "react";

import { Phone, Email } from "@material-ui/icons";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import AuthorisedLabel from "./AuthorisedLabel";
import { MultiLineStrings } from "imagus-components";

type CompanyInfoPropsType = {
  company: { [key: string]: string } | null,
  tableStyle?: { [key: string]: string },
  isEditable?: boolean,
  editCompany?: Function
};

class CompanyInfo extends Component<CompanyInfoPropsType, *> {
  constructor(props) {
    super(props);
  }

  editCompany = (): * => {
    if (this.props.isEditable) {
      this.props.editCompany && this.props.editCompany();
    }
    else {
      console.log();
    }
  }

  render(): * {
    const company = this.props.company;
    const contentClassName = this.props.isEditable ? "normal editable" : "normal";
    if (company) {
      return (
        <Table className="app-table no-border" style={this.props.tableStyle}>
          <TableBody>
            <TableRow>
              <TableCell padding="dense" className="border">Company Name</TableCell>
              <TableCell padding="dense" className={contentClassName} onClick={this.editCompany}>{company.name}</TableCell>
              <TableCell padding="dense" className="border">ABN No.</TableCell>
              <TableCell padding="dense" className={contentClassName} onClick={this.editCompany}>{company.abn}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell padding="dense" className="border" style={{ verticalAlign: "top" }}>Address</TableCell>
              <TableCell padding="dense" className={contentClassName} onClick={this.editCompany} colSpan="3">
                <div>
                  <p>
                    {company.address}
                    {company.address !== "" && company.suburb !== "" && ", "}
                    {company.suburb}
                  </p>
                  <p>
                    {company.state}
                    {company.state !== "" && company.postcode !== "" && " "}
                    {company.postcode}
                  </p>
                  <p>
                    {company.city}
                    {company.country !== "" && company.city !== "" && ", "}
                    {company.country}
                  </p>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell padding="dense" className="border">Contact Person</TableCell>
              <TableCell padding="dense" className={contentClassName} onClick={this.editCompany} colSpan="3">
                {company.contactName &&
                  (
                    <div>
                      <span>{company.contactName}</span>
                      <Phone className="tiny-icon green-icon" style={{ margin: "0 5px 0 15px", verticalAlign: "bottom" }} />
                      <span>{company.contactNumber}</span>
                      <Email className="tiny-icon green-icon" style={{ margin: "0 5px 0 15px", verticalAlign: "bottom" }} />
                      <span>{company.contactEmail}</span>
                    </div>
                  )
                  ||
                  ""
                }
              </TableCell>
            </TableRow>
            {company.level === "R" &&
              <TableRow>
                <TableCell padding="dense" className="border">Is Authorised Reseller?</TableCell>
                <TableCell padding="dense" colSpan="3" className="normal"><AuthorisedLabel status={company.authorisedReseller} /></TableCell>
              </TableRow>
            }
            <TableRow>
              <TableCell padding="dense" className="border" style={{ verticalAlign: "top" }}>Notes</TableCell>
              <TableCell padding="dense" colSpan="3" className={contentClassName} onClick={this.editCompany}><MultiLineStrings val={company.notes} /></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      );
    }
    else {
      return null;
    }
  }
}

export default CompanyInfo;
